import { InjectionToken } from '@angular/core';

export const AUTH_API_CONFIGURATION = new InjectionToken<AuthApiConfiguration>('reflaunt-auth.api-configuration');

export class AuthApiConfiguration {
  apiUrl: string;
}
